var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Cards/Hotels/Hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Cards/Hotels/Hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Cards"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A12885",
    fillRule: "nonzero",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "hotel",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666667,21.6666667 C14.4333333,21.6666667 16.6666667,19.4333333 16.6666667,16.6666667 C16.6666667,13.9 14.4333333,11.6666667 11.6666667,11.6666667 C8.9,11.6666667 6.66666667,13.9 6.66666667,16.6666667 C6.66666667,19.4333333 8.9,21.6666667 11.6666667,21.6666667 Z M31.6666667,11.6666667 L21.6666667,11.6666667 C19.8333333,11.6666667 18.3333333,13.1666667 18.3333333,15 L18.3333333,23.3333333 L5,23.3333333 L5,10 C5,9.08333333 4.25,8.33333333 3.33333333,8.33333333 C2.41666667,8.33333333 1.66666667,9.08333333 1.66666667,10 L1.66666667,31.6666667 C1.66666667,32.5833333 2.41666667,33.3333333 3.33333333,33.3333333 C4.25,33.3333333 5,32.5833333 5,31.6666667 L5,28.3333333 L35,28.3333333 L35,31.6666667 C35,32.5833333 35.75,33.3333333 36.6666667,33.3333333 C37.5833333,33.3333333 38.3333333,32.5833333 38.3333333,31.6666667 L38.3333333,18.3333333 C38.3333333,14.65 35.35,11.6666667 31.6666667,11.6666667 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.723a2f0382fc7a4d55ca626f1f9c7ce3.svg";
export { ForwardRef as ReactComponent };